import React, { useState } from "react";
import { Button, Card, Col, Form, Image, Input, Row } from "antd";
import { useParams } from "react-router-dom";
import CONSTANTS, { loginRoot } from "../../../util/constant/CONSTANTS";
import logo from "../../../asset/logos/icon.svg";
import useHttp from "../../../hooks/use-http";
import Label from "../../../component/common/Label";
import { apiGenerator } from "../../../util/functions";

const ResetPassword = () => {
    const { token } = useParams();
    const [password, setPassword] = useState('')
    const API = useHttp();

    const [form] = Form.useForm();
    const validateLogin = () => {
        const payload = {
            newPassword: password,
        };
        const RESET_PASSWORD_API = apiGenerator(CONSTANTS.API.reset_password, {}, `/${token}`);
        API.sendRequest(
            RESET_PASSWORD_API,
            (res) => {
            
                window.setTimeout(() => {
                    window.location.assign(loginRoot);
                    form.resetFields()
                }, 700)

            },
            payload,
            "Password Reset Successfully!!!"
        );
    };

    return (
        <>

            <div
                className="h-screen flex justify-center  items-center"

            >
                <Row className="">
                    <Col span={10} sm={24} xs={24} md={10} lg={10}>
                        <div className="mr-10  flex content-center justify-center">
                            <Image
                                src={logo}
                                alt="Bash"
                                preview={false}
                                width={300}
                                className="p-5"
                            />
                        </div>
                    </Col>
                    <Col span={14} sm={24} xs={24} md={14} lg={14}>
                        <Card style={{ background: "#F5F5F5", width: '440px', border: "none" }}>
                            <p className="text-3xl mb-4  font-medium	">New Password</p>

                            <Form
                                form={form}
                                name="normal_login"
                                className="login-form"
                                initialValues={{
                                    remember: true,
                                }}
                                onFinish={validateLogin}
                            >
                                <Label required >New Password</Label>
                                <Form.Item
                                    className="mt-1 mb-5 "
                                    name="newPassword"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter Password!",
                                        },
                                    ]}
                                >
                                    <Input.Password
                                        placeholder="Enter New Password..."
                                        onChange={(e) => {
                                            setPassword(e.target.value)
                                        }}
                                    />
                                </Form.Item>
                                <Label required >Confirm Password</Label>
                                <Form.Item
                                    className="mt-1 mb-5 "
                                    name="confirmPassword"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter Confirm Password!",
                                        },
                                        {
                                            validator: (_, value) => {
                                                if (value && value !== password) {
                                                    return Promise.reject(
                                                        new Error(
                                                            "The Passwords does not match. Please Correct and Try again!"
                                                        )
                                                    );
                                                }
                                                return Promise.resolve();
                                            },
                                        }
                                    ]}
                                >
                                    <Input.Password
                                        placeholder="Enter Confirm Password..."
                                    />
                                </Form.Item>

                                <Form.Item>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        className="login-form-button my-2"
                                        loading={API?.isLoading}

                                    >
                                        Submit
                                    </Button>
                                </Form.Item>


                            </Form>
                            <div>
                            </div>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
};
export default ResetPassword;
